import { hFetch } from '@/lib/hfetch';
import type {
  WorkflowConditionConditionType,
  WorkflowExpressionGroup,
} from './entity_types/workflow/WorkflowCondition';
import type { WorkflowTriggerDefinitionKey } from './entity_types/workflow/WorkflowDefinition';

type CreateWorkflowConditionArgs = {
  workflowId: number;
  expression: WorkflowExpressionGroup;
  triggerDefinitionKey: WorkflowTriggerDefinitionKey;
  conditionType: WorkflowConditionConditionType;
};
export const createWorkflowCondition = ({
  workflowId,
  expression,
  triggerDefinitionKey,
  conditionType,
}: CreateWorkflowConditionArgs) => {
  return hFetch({
    url: `/api/workflows/${workflowId}/condition`,
    method: 'POST',
    payload: {
      workflow_condition: { expression, trigger_definition_key: triggerDefinitionKey, condition_type: conditionType },
    },
  });
};

type UpdateWorkflowConditionArgs = {
  workflowId: number;
  expression: WorkflowExpressionGroup;
  conditionType: WorkflowConditionConditionType;
};
export const updateWorkflowCondition = ({ workflowId, expression, conditionType }: UpdateWorkflowConditionArgs) => {
  return hFetch({
    url: `/api/workflows/${workflowId}/condition`,
    method: 'PUT',
    payload: {
      workflow_condition: { expression, condition_type: conditionType },
    },
  });
};

type DeleteWorkflowConditionArgs = {
  workflowId: number;
  conditionType: WorkflowConditionConditionType;
};
export const deleteWorkflowCondition = ({ workflowId, conditionType }: DeleteWorkflowConditionArgs) => {
  return hFetch({
    url: `/api/workflows/${workflowId}/condition`,
    method: 'DELETE',
    payload: {
      workflow_condition: { condition_type: conditionType },
    },
  });
};
